import { FileContentTypeEnum } from '@openapi'
import type { CollectionSlide } from '@collection-player/types/collection-player.type'

export const isVideo = (slide?: CollectionSlide) =>
  slide?.type === 'file' && slide?.file?.content_type === FileContentTypeEnum.VIDEO

export const isImage = (slide?: CollectionSlide) =>
  slide?.type === 'file' && slide?.file?.content_type === FileContentTypeEnum.IMAGE

export const isWeb = (slide?: CollectionSlide) =>
  slide?.type === 'file' && slide?.file?.content_type === FileContentTypeEnum.WEB

export const isSlide = (slide?: CollectionSlide) => slide?.type === 'slide'
